export const ELEM_BYTES_LEN = 32;
export const DATA_LEN = 8;
export const DATA_LEN_BYTES = DATA_LEN * ELEM_BYTES_LEN;
//# sourceMappingURL=data.js.map